var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaizhi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4120_19233)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 8,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 6,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 10,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 14,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 10,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 14,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 14,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 2,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 6,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 10,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 14,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 6,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 10,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 6,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 10,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 14,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 2,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 10,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 4,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 2,
    height: 2,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 4,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 8,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 12,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 8,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 4,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 8,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 4,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 8,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 12,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 2,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 2,
    height: 2,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4120_19233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaizhi);
export default __webpack_public_path__ + "static/media/caizhi.2182bb95a3ae47e67af86a3105c921c7.svg";
export { ForwardRef as ReactComponent };